import React from "react";
import BlogPost from "@/pages/BlogPost";

const NewsletterPost = () => (
  <BlogPost
    apiPath="/newsletter/posts"
    basePath="/newsletter"
    backLabel="Newsletter"
    relatedHeading="More dispatches from Dr. Campbell"
    moreCta="Back to all dispatches"
    testIdPrefix="newsletter-post"
  />
);

export default NewsletterPost;
